namespace gotoAndPlay {

    /**
     * @brief      Button class
     */
    export class Button {

        constructor() {
        }
    }
}
